import { FiscalEvent } from '../../types/fiscal/FiscalEvent';
import FiscalEventStatusBadge from './FiscalEventStatusBadge';
import FiscalEventTypeBadge from './FiscalEventTypeBadge';
import ActionPanelButtons from '../DataTable/ActionPanelButtons';

export default function FiscalEventsList({ events, onOpen }: { events: FiscalEvent[]; onOpen: (event: FiscalEvent) => void }) {
  return <div className="overflow-x-auto"><table className="w-full min-w-[720px] text-left text-sm">
    <thead><tr className="border-b border-stroke"><th className="p-3">Evento</th><th>Tipo</th><th>Estado</th><th>Generación</th><th>Fecha</th><th></th></tr></thead>
    <tbody>{events.map((event) => <tr key={event.id} className="border-b border-stroke">
      <td className="p-3">#{event.id}</td><td><FiscalEventTypeBadge type={event.eventType} /></td><td><FiscalEventStatusBadge status={event.status} /></td>
      <td className="max-w-[220px] truncate">{event.generationCode || '—'}</td><td>{event.createdAt ? new Date(event.createdAt).toLocaleString() : '—'}</td>
      <td className="p-3">
        <ActionPanelButtons
          actions={[{ key: 'view', label: 'Ver detalle', onClick: () => onOpen(event) }]}
          row={event}
        />
      </td>
    </tr>)}{!events.length && <tr><td colSpan={6} className="p-8 text-center text-gray-500">No hay eventos para mostrar.</td></tr>}</tbody>
  </table></div>;
}
